import { ReactElement, ReactNode } from 'react';
import { noop } from 'lodash';

import styles from './Tab.scss';

interface Props {
  active?: boolean;
  children?: ReactNode;
  className?: string;
  done?: boolean;
  home?: boolean;
  nested?: boolean;
  onClick?: () => void;
  progress?: boolean;
}

const Tab = ({
  active = false,
  nested = false,
  home = false,
  progress = false,
  done = false,
  children = 'Title',
  onClick = noop,
  className = '',
}: Props): ReactElement => {
  const defaultClassName = `title${active ? '_active' : ''}${nested ? '_nested' : ''}${
    home ? '_home' : ''
  }${progress ? '_progress' : ''}${done ? '_done' : ''}`;

  return (
    <div
      className={`${styles[defaultClassName]} ${className}`}
      onClick={!progress || done ? onClick : noop}
    >
      {children}
    </div>
  );
};

export default Tab;
